import React from 'react';

import { SectionWrapper } from '@components/SectionWrapper';
import { ExperienceCard } from '@components/ExperienceCard';
import { DoubleColorBackground } from '@components/DoubleColorBackground';

import { useCalculateBackgroundForExperience } from '@hooks';

import { EHashLinks } from '@enum';

export const Experience = () => {
  const height = useCalculateBackgroundForExperience();

  return (
    <SectionWrapper
      sectionId={EHashLinks.experience}
      background={<DoubleColorBackground colorHeight={height} />}
    >
      <ExperienceCard />
    </SectionWrapper>
  );
};
